var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleWarning = function SvgCircleWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.666a.648.648 0 0 1-.647-.625l-.156-4.376a.804.804 0 1 1 1.607 0l-.156 4.376a.648.648 0 0 1-.648.625ZM10 14.166a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.333a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667Zm0-1.25a7.083 7.083 0 1 0 0-14.167 7.083 7.083 0 0 0 0 14.167Z"
  })));
};
export default SvgCircleWarning;